import apiClient from './client';

export type ProviderId = 'gemini' | 'openai' | 'anthropic' | 'ollama' | string;

export type ProviderSecretStatus = {
  provider: ProviderId;
  configured: boolean;
  last4?: string | null;
};

export type ProviderInfo = {
  id: ProviderId;
  label: string;
  requires_api_key: boolean;
  default_model: string;
  models: string[];
  api_key_help?: string;
};

export type LLMPreference = {
  provider: ProviderId | null;
  model: string | null;
  available_providers: ProviderInfo[];
  status_per_provider: ProviderSecretStatus[];
};

export const userSecretsApi = {
  list: async (): Promise<ProviderSecretStatus[]> => {
    const r = await apiClient.get('/api/user/secrets');
    return r.data;
  },

  getStatus: async (provider: ProviderId): Promise<ProviderSecretStatus> => {
    const r = await apiClient.get(`/api/user/secrets/${encodeURIComponent(provider)}`);
    return r.data;
  },

  setKey: async (provider: ProviderId, api_key: string): Promise<ProviderSecretStatus> => {
    const r = await apiClient.put(`/api/user/secrets/${encodeURIComponent(provider)}`, { api_key });
    return r.data;
  },

  deleteKey: async (provider: ProviderId): Promise<ProviderSecretStatus> => {
    const r = await apiClient.delete(`/api/user/secrets/${encodeURIComponent(provider)}`);
    return r.data;
  },
};

export const llmPreferenceApi = {
  get: async (): Promise<LLMPreference> => {
    const r = await apiClient.get('/api/user/llm-preference');
    return r.data;
  },

  set: async (provider: ProviderId | null, model: string | null): Promise<LLMPreference> => {
    const r = await apiClient.put('/api/user/llm-preference', { provider, model });
    return r.data;
  },
};

/**
 * Anonymous (no auth) listing of user-selectable providers + their curated models.
 * Used by the registration screen before an account exists.
 */
export const llmProvidersApi = {
  list: async (): Promise<ProviderInfo[]> => {
    const r = await apiClient.get('/api/llm-providers');
    return r.data;
  },
};
